import { useRef } from "react";
import useEffectOnce from "../hooks/useEffectOnce";

export const useHideKeyboardOnScroll = () => {
    const scrollRef = useRef(0);
    useEffectOnce(() => {
        const handleScroll = e => {
            if (scrollRef.current < e.target.scrollTop) {
                document.activeElement.blur(); // try hide user keyboard
            }
            scrollRef.current = e.target.scrollTop;
        };
        window.addEventListener('scroll', handleScroll, true);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
}
